<template>
    <Carousel class="carousel-grid" :items="items" :breakpoints="breakpoints">
        <template #slide="{item}">
            <slot name="slide" :item="item" />
        </template>
    </Carousel>
</template>

<script setup lang="ts">
    import Carousel from '~/components/Carousel.vue';

    defineProps<{items: any[]}>();

    const breakpoints = {
        0: {enabled: true, slidesPerView: 1},
        480: {enabled: true, slidesPerView: 2},
        768: {enabled: true, slidesPerView: 3},
        992: {enabled: true, slidesPerView: 4},
        1200: {
            enabled: false,
        },
    };
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    @include mq.screen_md(min) {
        .carousel-grid {
            margin: 0;
            opacity: 1;

            .swiper {
                overflow: visible;
            }
            .swiper-wrapper {
                flex-wrap: wrap;
                transform: none !important;
                display: grid;
                grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
                gap: 20px;
            }
            .swiper-slide {
                height: auto;
                width: auto !important;
                margin-right: 0 !important;
            }
            .swiper-button {
                display: none !important;
            }
        }
    }
</style>
